// A webhook form's checks — the server's (app/modules/console/routers/
// webhooks.py + app/modules/events/delivery.py check_url): a name, an
// absolute http(s) address with a host and no user/password, https only
// while the deployment requires it (GET …/webhooks/rules says). Where the
// host resolves is the server's to judge.

import i18n from '@/i18n';

export const DEFAULT_WEBHOOK_RULES = { require_https: true, name_max: 120, url_max: 2048, events_max: 50 };

const t = (key, params) => i18n.t(`errors:fields.${key}`, params);

export function webhookUrlProblem(raw, rules = DEFAULT_WEBHOOK_RULES) {
  const value = (raw || '').trim();
  if (!value) return t('required');
  if (value.length > rules.url_max) return t('tooLong', { max: rules.url_max });
  let url;
  try {
    url = new URL(value);
  } catch {
    return t('url');
  }
  if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) return t('url');
  if (url.protocol === 'http:' && rules.require_https) return t('https');
  if (url.username || url.password) return t('credentials');
  return null;
}

export function webhookProblems({ name, url, types }, rules = DEFAULT_WEBHOOK_RULES) {
  const out = {};
  const n = (name || '').trim();
  if (!n) out.name = t('required');
  else if (n.length > rules.name_max) out.name = t('tooLong', { max: rules.name_max });
  const urlProblem = webhookUrlProblem(url, rules);
  if (urlProblem) out.url = urlProblem;
  if ((types || []).length > rules.events_max) out.event_types = t('tooMany', { max: rules.events_max });
  return out;
}

// The server's `webhook_url_refused` names its rule in `params.reason`.
export function refusedUrlText(reason) {
  const own = { scheme: 'url', https: 'https', credentials: 'credentials' }[reason];
  if (own) return t(own);
  const key = `console:webhooks.form.refused.${reason}`;
  return i18n.exists(key) ? i18n.t(key) : i18n.t('errors:webhook_url_refused');
}
